<template>
  <div class="item-container">
    <div class="title" v-if="keywords === undefined">{{title}}</div>
    <div class="title" v-if="keywords !== undefined">下面是&nbsp;&nbsp;<strong style="color:#f10215">{{keywords}}</strong>&nbsp;&nbsp;的搜索结果</div>
    <div
      class="item"
      v-for="(item, index) in newsList"
      :key="item.id"
      :style="index === newsList.length - 1 ? {border: 'none'} : ''"
    >
      <img class="item-img"
           v-if="item.thumbnail !== '' && item.thumbnail !== null"
           :src="item.thumbnail"
           @click="toDetail(item.id)"/>
      <div class="content">
        <div class="news-title">
          <span @click="toDetail(item.id)" v-html="item.title.replace(/<br \/>/g,'&nbsp;')"></span>
          <span>{{item.check_time}}</span>
        </div>
        <div class="sub-title" v-if="item.subtitle !== null" @click="toDetail(item.id)">
          {{item.subtitle.length >= 130 ? item.subtitle.substring(0, 130) + '...' : item.subtitle}}
        </div>
      </div>
    </div>

    <div class="page-wrapper">
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :hide-on-single-page="true"
        :total="total"
        :page-size="5"
        :current-page="currentPage"
        :prev-text="'上一页'"
        :next-text="'下一页'"
        @current-change="handlePage"
        @prev-click="handlePage"
        @next-click="handlePage">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { requestUrl, orgId } from '../common/cons'
import { mapGetters } from 'vuex'

export default {
  name: 'NewsItem',
  data () {
    return {
      id: '',
      title: '',
      newsList: [],
      total: 10,
      currentPage: 1,
      keywords: null
    }
  },
  computed: {
    ...mapGetters({
      columnId: 'getColumnId',
      mainColumnId: 'getMainColumn'
    })
  },
  watch: {
    columnId: function (columnId) {
      this.id = columnId
      this.initPagination()
      this.initDefaultNewsList(columnId)
    },
    mainColumnId: function (mainColumnId) {
      this.id = mainColumnId
      this.initPagination()
      this.initDefaultNewsList(mainColumnId)
    }
  },
  async mounted () {
    this.id = this.$route.params.id
    this.initPagination()
    this.keywords = this.$route.query.keywords
    await this.initDefaultNewsList(this.id)
  },
  methods: {
    async initDefaultNewsList (columnId) {
      if (this.keywords) {
        await this.initSearchNewsList()
      } else {
        const result = await axios.get(`${requestUrl}/news/${columnId}?orgId=${orgId}&offset=${this.currentPage - 1}&limit=5`)
        this.total = result.data.total
        this.newsList = result.data.type
        this.title = result.data.channel.name
      }
    },
    async initSearchNewsList () {
      const result = await axios.get(`${requestUrl}/news/search?title=${this.keywords}&orgId=${orgId}&offset=${this.currentPage - 1}&limit=5`)
      this.total = result.data.total
      this.newsList = result.data.type
    },
    toDetail (id) {
      const routePath = this.$router.resolve({
        path: `/content/${id}`
      })
      window.open(routePath.href)
    },
    async handlePage (page) {
      this.currentPage = page
      await this.initDefaultNewsList(this.id)
    },
    initPagination () {
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
.item-container {
  max-height: 880px;
  width: 940px;
  box-sizing: border-box;
  padding: 30px;
  border: 1px solid #cccccc;
  background-color: white;
}

.title {
  font-size: 24px;
  color: #088A29;
  font-weight: 700;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 14px;
}

.item {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 10px;
}

.item-img {
  width: 180px;
  height: 120px;
  margin-right: 20px;
  cursor: pointer;
}

.content {
  flex: 1;
  margin-top: 8px;
}

.news-title {
  display: flex;
  justify-content: space-between;
}

.news-title span:first-child {
  font-size: 16px;
  color: #333333;
  font-weight: 700;
}

.news-title span:first-child:hover {
  color: #088A29;
  cursor: pointer;
}

.news-title span:last-child {
  font-size: 12px;
  color: #aaa;
}

.sub-title {
  margin-top: 20px;
  font-size: 13px;
  line-height: 1.5;
  color: #888;
}

.page-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-wrapper >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #5daf34;
}
.pagination {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsItem.vue